import React from 'react';
import {isMobile} from 'react-device-detect';

import ReactGA from 'react-ga';
import axios from 'axios';

export default class Splash_News extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            news: [],
            newNewsItems: [],
            newUniversityItems: [],
            newReleaseItems: [],
        }
    }

    componentDidMount = () => {
        this.getNews();
    }

    getNews = (input, callback) => {
        var data = new FormData();
        axios.post('/code/api_master.php?api=getNews', data)
            .then(response => {
                if (parseInt(response.data.status) === 1) {
                    if (Object.keys(response.data.data).length > 0) {
                        this.setState({news: response.data})
                        this.renderNews();
                        this.renderUniversities();
                        this.renderReleases();
                    }
                }
                return response;
            });
    }

    renderNews = () => {
        let news = this.state.news
        let rst = news.data
        let newNewsItems = []
        for (var item of rst.news) {
            newNewsItems.push(
                <div className="col-sm-12 col-lg-4">
                    <ul role="list">
                        <li className="list">
                            <a href={item.link} target="_blank" className="link-6"><strong className="bold-text-4">{item.title}</strong></a><br/>
                            <strong>{item.sub_title} – {item.date}</strong>
                        </li>
                    </ul>
                </div>
            );
        }
        this.setState({newNewsItems: newNewsItems});
    }

    renderUniversities = () => {
        let news = this.state.news
        let rst = news.data
        let newUniversityItems = []
        for (var item of rst.universities) {
            newUniversityItems.push(
                <div className="col-sm-12 col-lg-4">
                    <ul role="list">
                        <li className="list">
                            <a href={item.link} target="_blank" className="link-6"><strong className="bold-text-4">{item.title}</strong></a><br/>
                            <strong>{item.sub_title} – {item.date}</strong>
                        </li>
                    </ul>
                </div>
            );
        }
        this.setState({newUniversityItems: newUniversityItems});
    }

    renderReleases = () => {
        let news = this.state.news
        let rst = news.data
        let newReleaseItems = []
        for (var item of rst.releases) {
            newReleaseItems.push(
                <div className="col-sm-12 col-lg-4">
                    <ul role="list">
                        <li className="list">
                            <a href={item.link} target="_blank" className="link-6"><strong className="bold-text-4">{item.title}</strong></a><br/>
                            <strong>{item.sub_title} – {item.date}</strong>
                        </li>
                    </ul>
                </div>
            );
        }
        this.setState({newReleaseItems: newReleaseItems});
    }

    render() {
        return (
            <div id="press-releases">
                <h1>Versity in the Media</h1>
                <div className="s-40">&nbsp;</div>
                <div className="logos-wrapper press-logos">
                    <div className="logos logos-news">
                        <div className="logo logo-press-1">&nbsp;</div>
                        <div className="logo logo-press-2">&nbsp;</div>
                        <div className="logo logo-press-3">&nbsp;</div>
                        <div className="logo logo-press-4">&nbsp;</div>
                    </div>
                </div>
                {this.state.newNewsItems.length > 0 ?
                <div className={isMobile ? "page_wrapper_mobile" : "page_wrapper"}>
                    <h2>News</h2>
                    <div className="s-40">&nbsp;</div>
                    <div className="now pd0">
                        {this.state.newNewsItems}
                    </div>
                </div>
                    : ""}
                {this.state.newUniversityItems.length > 0 ?
                <div className={isMobile ? "page_wrapper_mobile" : "page_wrapper"}>
                    <h2>University Press</h2>
                    <div className="s-40">&nbsp;</div>
                    <div className="now pd0">
                        {this.state.newUniversityItems}
                    </div>
                </div>
                    : ""}
                {this.state.newReleaseItems.length > 0 ?
                <div className={isMobile ? "page_wrapper_mobile" : "page_wrapper"}>
                    <h2>Press Releases</h2>
                    <div className="s-40">&nbsp;</div>
                    <div className="now pd0">
                        {this.state.newReleaseItems}
                    </div>
                </div>
                    : ""}
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/splash_news.js
 **/